<template>
  <section class="sac-step sac-step--3" v-if="model.etapaAtiva == 3 && !formSent">
    <div class="wrapper">
      <div class="form-grid sac-review">

        <ProductCard class="col--wide" v-for="(item, i) in model.produtos" :key="i"
          :model="item"
          :index="i"
          :exclude="false"
          @edit="setProdutoEdit"
          ></ProductCard>

        <div class="sac-product-card">
          <div class="sac-product-card__header">
            <h3 class="form-sec-title">{{ _e('sac_review_personal') }}</h3>
            <button type="button" class="btn-edit" @click.stop="handleEdit">
              <span class="btn-edit__label">{{ _e('sac_edit_label') }}</span>
              <span class="btn-edit__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0605 2C16.4665 2 16.8586 2.14054 17.1699 2.39551L17.2979 2.51172L21.4873 6.69922C21.8152 7.02737 22 7.4726 22 7.93652C22 8.40045 21.8162 8.84568 21.4883 9.17383L18.7197 11.9424C18.7153 11.947 18.7116 11.9525 18.707 11.957C18.7025 11.9616 18.697 11.9653 18.6924 11.9697L11.4141 19.25H20.25C20.8022 19.25 21.2499 19.6978 21.25 20.25C21.25 20.8023 20.8023 21.25 20.25 21.25H4.5C4.03587 21.25 3.59089 21.0655 3.2627 20.7373C2.93454 20.4091 2.75 19.9641 2.75 19.5V15.3096L2.75879 15.1377C2.79855 14.7375 2.97509 14.3612 3.26172 14.0742L14.8242 2.51172C15.1523 2.18412 15.5969 2.00006 16.0605 2ZM4.75 15.4141V19.25H8.58594L16.584 11.248L12.75 7.41406L4.75 15.4141ZM14.1641 6L17.998 9.83398L19.8965 7.93555L16.0605 4.10254L14.1641 6Z" fill="currentColor"/></svg>
              </span>
            </button>
          </div>

          <div class="sac-product-card__body">
            <div class="sac-product-card__field col--wide col--md-6">
              <span class="sac-product-card__label">{{ _e('sac_nome_label') }}</span>
              <p class="sac-product-card__value">{{ model.nome }}</p>
            </div>
            <div class="sac-product-card__field col--wide col--md-6">
              <span class="sac-product-card__label">{{ _e('sac_email_label') }}</span>
              <p class="sac-product-card__value">{{ model.email }}</p>
            </div>

            <div class="sac-product-card__field col--wide col--md-6">
              <span class="sac-product-card__label">{{ _e('sac_phone_label') }}</span>
              <p class="sac-product-card__value">{{ model.telefone }}</p>
            </div>
            <div class="sac-product-card__field col--wide col--md-6">
              <span class="sac-product-card__label">{{ _e('sac_phone2_label') }}</span>
              <p class="sac-product-card__value">{{ model.telefone2 }}</p>
            </div>
          </div>
        </div>

        <div class="sac-product-card">
          <div class="sac-product-card__header">
            <h3 class="form-sec-title">{{ _e('sac_review_personal3') }}</h3>
            <button type="button" class="btn-edit" @click.stop="handleEdit">
              <span class="btn-edit__label">{{ _e('sac_edit_label') }}</span>
              <span class="btn-edit__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0605 2C16.4665 2 16.8586 2.14054 17.1699 2.39551L17.2979 2.51172L21.4873 6.69922C21.8152 7.02737 22 7.4726 22 7.93652C22 8.40045 21.8162 8.84568 21.4883 9.17383L18.7197 11.9424C18.7153 11.947 18.7116 11.9525 18.707 11.957C18.7025 11.9616 18.697 11.9653 18.6924 11.9697L11.4141 19.25H20.25C20.8022 19.25 21.2499 19.6978 21.25 20.25C21.25 20.8023 20.8023 21.25 20.25 21.25H4.5C4.03587 21.25 3.59089 21.0655 3.2627 20.7373C2.93454 20.4091 2.75 19.9641 2.75 19.5V15.3096L2.75879 15.1377C2.79855 14.7375 2.97509 14.3612 3.26172 14.0742L14.8242 2.51172C15.1523 2.18412 15.5969 2.00006 16.0605 2ZM4.75 15.4141V19.25H8.58594L16.584 11.248L12.75 7.41406L4.75 15.4141ZM14.1641 6L17.998 9.83398L19.8965 7.93555L16.0605 4.10254L14.1641 6Z" fill="currentColor"/></svg>
              </span>
            </button>
          </div>

          <div class="sac-product-card__body">
            <div class="sac-product-card__field col--wide">
              <span class="sac-product-card__label">{{ _e('sac_cep_label') }}</span>
              <p class="sac-product-card__value">{{ model.cep }}</p>
            </div>
            <div class="sac-product-card__field col--wide">
              <span class="sac-product-card__label">{{ _e('sac_endereco_label') }}</span>
              <p class="sac-product-card__value">{{ model.endereco }}</p>
            </div>

            <div class="sac-product-card__field col--wide col--md-4">
              <span class="sac-product-card__label">{{ _e('sac_bairro_label') }}</span>
              <p class="sac-product-card__value">{{ model.bairro }}</p>
            </div>
            <div class="sac-product-card__field col--wide col--md-4">
              <span class="sac-product-card__label">{{ _e('sac_numero_label') }}</span>
              <p class="sac-product-card__value">{{ model.numero }}</p>
            </div>
            <div class="sac-product-card__field col--wide col--md-4">
              <span class="sac-product-card__label">{{ _e('sac_complemento_label') }}</span>
              <p class="sac-product-card__value">{{ model.complemento }}</p>
            </div>

            <div class="sac-product-card__field col--wide col--md-6">
              <span class="sac-product-card__label">{{ _e('sac_estado_label') }}</span>
              <p class="sac-product-card__value">{{ model.estado }}</p>
            </div>
            <div class="sac-product-card__field col--wide col--md-6">
              <span class="sac-product-card__label">{{ _e('sac_cidade_label') }}</span>
              <p class="sac-product-card__value">{{ model.cidade }}</p>
            </div>
          </div>
        </div>

        <div class="sac-separator col--wide"></div>

        <form @submit.stop.prevent="handleSubmit($event)" class="form form-grid col--wide" :class="{'form--sending':formLoading, 'form--validated': formShowError}" v-if="!formSent" novalidate>

          <div class="col--wide">
            <CheckInput :options="termsConditions" v-model="model.termos" :required="true"></CheckInput>
          </div>

          <div class="col--wide">
            <VueTurnstile :site-key="config.TURNSTILE_KEY" v-model="token" theme="light"></VueTurnstile>
          </div>

          <div class="sac-actions">
            <button type="button" class="btn" @click.stop.prevent="model.irParaEtapa(2)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.15 5.91847L11.3109 4.53979C10.5943 5.70944 9.89257 6.73839 9.20568 7.62663C8.50383 8.50005 7.78699 9.2846 7.05514 9.98026C6.32329 10.6759 5.5391 11.3271 4.70258 11.9339L4.70266 12.0672C5.53997 12.6602 6.32501 13.305 7.05777 14.0016C7.79053 14.6982 8.50841 15.4911 9.21141 16.3803C9.89945 17.2546 10.6025 18.2845 11.3207 19.4699L13.158 18.0714C12.5446 17.1378 11.9164 16.3006 11.2733 15.5596C10.6302 14.8186 9.98711 14.1813 9.34412 13.6476C8.70113 13.0992 8.07315 12.6618 7.46019 12.3356C6.84722 11.9945 6.26421 11.7571 5.71116 11.6235L5.71165 12.3789C6.26453 12.2459 6.84723 12.0093 7.45976 11.669C8.07228 11.3288 8.69968 10.8923 9.34197 10.3595C9.98425 9.81185 10.6265 9.17537 11.2686 8.45002C11.9108 7.70986 12.5379 6.86602 13.15 5.91847ZM19.6319 10.8105L12.4807 10.8059C11.4645 10.8052 10.5454 10.8416 9.72343 10.9151C8.88656 10.9886 8.1319 11.0844 7.45945 11.2025L5.958 12.0013L7.4605 12.8021C8.13309 12.9063 8.88787 12.9956 9.72484 13.0702C10.5469 13.1448 11.466 13.1825 12.4823 13.1831L19.6335 13.1878L19.6319 10.8105Z" fill="currentColor"></path></svg>
              <span class="btn__label">{{ _e('sac_anterior') }}</span>
            </button>
            <button type="submit" class="btn btn--primary" v-if="!formLoading">
              <span class="btn__label">{{ _e('sac_submit') }}</span>
            </button>

            <div class="form__loading" v-if="formLoading">
              <span class="text">{{ _e('Enviando') }}</span>
              <span class="icon"></span>
            </div>
          </div>

        </form>
      </div>
    </div>
  </section>

  <FormSuccess v-if="formSent"></FormSuccess>
</template>
<script setup>
import { ref } from 'vue';
import { _e } from '../../../helpers/l10n';
import { useSacStore } from '../../../store/SacStore';

import VueTurnstile from 'vue-turnstile';

import ProductCard from '../ProductCard.vue';
import CheckInput from '../../form/inputs/CheckInput.vue';
import FormSuccess from '../FormSuccess.vue';
import config from '../../../helpers/config';

const model = useSacStore();

const termsConditions = _e('termos_condicoes');

const token = ref('');

const formSent = ref(false);
const formLoading = ref(false);
const formShowError = ref(false);

async function handleSubmit(e) {
  if(e.target.checkValidity()) {
    formShowError.value = false;
    formLoading.value = true;

    const url = _e('api_url');
    const formData = model.pegaFormData();

    formData.append('cf_token', token.value);

    const req = await fetch(url, {
      method: 'POST',
      body: formData
    });

    if(req.ok && req.status < 300) {
      const json = await req.json();

      formSent.value = true;
      formLoading.value = false;


      model.showSuccessForm = {
        title: json.title,
        text: json.text,
        link: json.link,
        link_label: json.link_label
      };

    } else {
      //Deu erro na request
      formLoading.value = false;
    }

  } else {
    formShowError.value = true;
    e.target.reportValidity();
  }
}

function setProdutoEdit(index) {
  model.irParaEtapa(1);
}

function handleEdit() {
  model.irParaEtapa(2);
}
</script>
